<div class="backDrop" *ngIf="showDialog$ | async">
    <div class="modal-dialog modal-s">
        <div class="modal-content" *ngIf="requestState$ | async as requestState">
            <!-- Modal Header -->
            <div class="modal-header ">
                <h4 class="modal-title">Request company access</h4>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                @switch(requestState) {
                    @case(RequestState.Unsent) {
                        <div>You currently do not have access to {{company.name}}.</div>
                        <div>Would you like to request access?</div>
                    }
                    @case(RequestState.Sending) {
                        <div>Sending request...</div>
                    }
                    @case(RequestState.Sent) {
                        <div>Access request successfully sent.</div>
                    }
                    @case(RequestState.Error) {
                        <div>An error occurred while sending the request.</div>
                        <div>{{errorMessage$ | async}}</div>
                    }
                }
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-success" *ngIf="[RequestState.Unsent, RequestState.Sending].includes(requestState)" [disabled]="requestState !== RequestState.Unsent" (click)="sendRequest()">
                    Request access
                </button>
                <button type="button" class="btn btn-primary" (click)="cancel()">
                    {{ [RequestState.Sent, RequestState.Error].includes(requestState) ? 'Ok' : 'Cancel' }}
                </button>
            </div>
        </div>
    </div>
</div>
